
import axios from "axios";
import AxiosClient from "../../../services/axios.services";

class FormEvalCapaServices {
  getFormEvalCapa = params =>
    AxiosClient.get("/api/app/formulario_capacitacion/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getFormEvalCapaById = id =>
    AxiosClient.get(`/api/app/formulario_capacitacion/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveFormEvalCapa = data =>
    AxiosClient.post("/api/app/formulario_capacitacion/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editFormEvalCapa = (id, data) =>
    AxiosClient.put(
      `/api/app/formulario_capacitacion/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteFormEvalCapa = id =>
    AxiosClient.delete(`/api/app/formulario_capacitacion/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
 
}



export default new FormEvalCapaServices();